import { DEFAULT_STUDIO_CATEGORY_SLUG } from './config';

export const appRoutes = {
  templates: {
    pattern: '/:categorySlug?',
    get: (slug: string) =>
      slug === DEFAULT_STUDIO_CATEGORY_SLUG ? '/' : `/${slug}`,
  },
  search: {
    get: (criteria: string) => `/?criteria=${encodeURIComponent(criteria)}`,
  },
};
